import wixWindow from 'wix-window';

export function responsifySection(box) {

    setInterval(async () => {
        const winWidth = await getWinWidth();
        //toggleBoxes(winWidth,boxes);
        if (winWidth > 1500) {
            if (box.collapsed) {
                box.expand();
            }
        } else {
            box.collapse();
        }
    }, 1000)

}

async function getWinWidth() {
    try {
        const winInfo = await wixWindow.getBoundingRect();
        const winWidth = winInfo.window.width;
        return winWidth;
    } catch (err) {
        console.error(`Failed to getWinWidth: ${err}`)
    }
}

export function toggleMenu(smallMenu, BigMenu) {
    setInterval(async () => {
        const winWidth = await getWinWidth();
        if (winWidth < 1750) {
            if (!BigMenu.hidden) {
                BigMenu.hide();
                smallMenu.show();
            }
        } else {
            BigMenu.show();
            smallMenu.hide();
        }
    }, 1000)
}

function toggleBoxes(winWidth, boxes) {
    boxes.forEach(box => {
        if (winWidth > 1500) {
            if (box.collapsed) {
                box.expand();
            }
        } else {
            box.collapse();
        }
    })
}

export function linkText(text, link, target = '_self') {
    const textHtml = text.html;
    if (textHtml.indexOf('href=') > -1) {
        text.html = textHtml.replace(
            textHtml.substring(textHtml.lastIndexOf("href=") + 5).split(' ')[0],
            link
        );
        return;
    }
    text.html = `<a href=${link} target=${target} style='display:block;'>${text.html}</a>`;
}